export default {

    /**
   * Обновляем состояние плеера
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {String} newState - Новое состояние
   */
    setPlayerState({ commit }, newState) {
        commit('SET_PLAYER_STATE', newState);
    },

    /**
   * Установить новый трек
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {Object} payload
   * @param {String} payload.id - id лида
   * @param {String} payload.record - Новый путь к треку
   */
    setRecord({ commit }, { id, record }) {
        commit('SET_RECORD', { id, record });
    },

    /**
   * Открыть/Закрыть плеер
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {Boolean} bool - Открыть или закрыть
   */
    toggle({ commit }, bool) {
        commit('TOGGLE', bool);
    },
};
